import type { TOC } from '@ember/component/template-only';
import type { ComponentLike } from '@glint/template';
import LiquidIf from 'liquid-fire/components/liquid-if';

import type { SettingsPanelBodyContentSignature } from './sp-body/sp-content';
import BodyContent from './sp-body/sp-content';

interface SettingsPanelBodySignature {
  Args: {
    isOpen?: boolean;
    liquidClass?: string;
  };
  Blocks: {
    default: [ComponentLike<SettingsPanelBodyContentSignature>];
  };
  Element: HTMLDivElement;
}

export default <template>
  {{! template-lint-disable no-at-class }}
  <LiquidIf @predicate={{@isOpen}} @class={{@liquidClass}}>
    <div data-test-settings-panel-body ...attributes>
      {{yield (component BodyContent)}}
    </div>
  </LiquidIf>
</template> satisfies TOC<SettingsPanelBodySignature>;
